<template>
  <div class="mr-3">
    <v-menu
      transition="scale-transition"
      class="cart"
      min-width="300"
      max-width="300"
      offset-y
      light
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="cart-btn"
          fab
          dark
          small
          color="accent"
          v-on="on"
          placement="bottom"
          :title="data.Cart_Tooltip_Label"
        >
          <v-badge right large color="accent">
            <template>
              <!-- <template v-if="cart.length > 0"> -->
              <span slot="badge">{{cart.length}}</span>
            </template>
            <v-icon dark>shopping_cart</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <div v-if="cart && cart.length > 0" class="cart-menu-list white">
        <emb-perfect-scrollbar class="scroll-area" style="max-height:280px">
          <v-list class="cart-list-items py-0" v-for="(cart, index) in cart" :key="index">
            <v-layout row wrap align-center cart-item ma-0>
              <v-flex sm12 md12 lg12 xl12 pa-0>
                <v-layout row wrap align-center class="ma-0">
                  <v-flex xs3 sm3 md3 lg3 xl3 pa-0>
                    <router-link :to="detailPage(cart.More_details_page_link)">
                      <img :src="cart.Product_Image_626_x_800px" width="60" height="70" />
                    </router-link>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 pa-0>
                    <div class="pl-1">
                      <router-link :to="detailPage(cart.More_details_page_link)">
                        <h6 class="word-wrap-break">{{cart.Name}}</h6>
                      </router-link>
                      <span>
                        <!-- <emb-currency-sign></emb-currency-sign> -->
                        {{$n((cart.sellingPrice * cart.quantitySelected)/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
                        <!-- {{$n(((cart.sellingPrice * cart.quantitySelected) / selectedCurrency.currencyRate))}} -->
                      </span>
                    </div>
                  </v-flex>
                  <v-flex sm4 md4 lg4 xl4 text-center pa-0 cart-action>
                    <v-btn class="primary d-inline-block" icon @click="deleteProductFromCart(cart)">
                      <v-icon>remove_shopping_cart</v-icon>
                    </v-btn>
                    <v-btn
                      class="primary d-inline-block ml-2 d-inline-flex align-items-center"
                      icon
                      to="/cart"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-list>
        </emb-perfect-scrollbar>
        <!-- <emb-delete-confirmation
          ref="deleteConfirmationDialog"
          message="Are you sure you want to delete this product?"
          @onConfirm="onDeleteProductFromCart"
        ></emb-delete-confirmation>-->
        <v-layout align-center pa-3>
          <v-btn class="accent white--text" block to="/cart">{{cartSection.Checkout_Button_Label}}</v-btn>
        </v-layout>
      </div>
      <div v-else class="text-center white pa-6">
        <v-icon size="31" class="accent--text">shopping_cart</v-icon>
        <h5>{{cartSection.No_Products_Label}}</h5>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
export default {
  components: {
    embPerfectScrollbar: VuePerfectScrollbar,
  },
  props: ["data"],
  data() {
    return {
      cartSection: "",
      selectDeletedProduct: null,
      settings: {
        maxScrollbarLength: 160,
      },
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  computed: {
    ...mapGetters(["cart", "selectCurrency", "currencies", "selectedLocale"]),
    // getTotalPrice() {
    //   let totalPrice = 0;
    //   if (this.cart.length > 0) {
    //     for (const item of this.cart) {
    //       totalPrice += item.total;
    //     }
    //     return totalPrice.toFixed(2);
    //   } else {
    //     return totalPrice;
    //   }
    // },
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  methods: {
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        // url = url.split(" ").join("-");
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
    deleteProductFromCart(product) {
      //   this.$refs.deleteConfirmationDialog.openDialog();
      //   this.selectDeletedProduct = product;

      this.$snotify.success(
        this.cmsRequestFunctions.getValidationMsgByCode("M024"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
        }
      );
      //   Vue.$toast.success(
      //     this.cmsRequestFunctions.getValidationMsgByCode("M024")
      //   );
      this.$store.dispatch("onDeleteProductFromCart", product);
    },
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "29 Cart/29 Cart/29 Cart.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var cartArea = self.cmsRequestFunctions.pluck(
              "Cart_Section",
              res.area_List
            );
            self.cartSection = self.cmsRequestFunctions.getAllMapData(
              cartArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>